import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

/* Columna de contenido: la barra superior y la tabla comparten ancho y sangrados,
   así el buscador y la tabla empiezan y acaban en el mismo borde. */
const CONTENT_MAX_WIDTH = "1350px";
const CONTENT_PAD_LEFT = "140px";
const CONTENT_PAD_RIGHT = "32px";

export const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px 14px 0;
  background: #fff;
  gap: 16px;
`;

export const TopBarInner = styled.div`
  flex: 1;
  min-width: 0;
  max-width: ${CONTENT_MAX_WIDTH};
  padding: 0 ${CONTENT_PAD_RIGHT} 0 ${CONTENT_PAD_LEFT};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 20px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: #f0fbfc; }
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 380px;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 0.9rem;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 9px 12px 9px 34px;
  border-radius: 20px;
  border: 1.5px solid #dce8f0;
  background: #f5f9fc;
  font-size: 0.85rem;
  color: #333;
  outline: none;
  box-sizing: border-box;

  &:focus { border-color: #26A9B6; background: #fff; }
`;

export const UserBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const UserName = styled.span`
  font-size: 0.88rem;
  font-weight: 600;
  color: #1b3a6b;
`;

export const UserAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Content = styled.div`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  padding: 28px ${CONTENT_PAD_RIGHT} 28px ${CONTENT_PAD_LEFT};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1.5px solid #26A9B6;
  background: ${({ $active }) => ($active ? "#26A9B6" : "#fff")};
  color: ${({ $active }) => ($active ? "#fff" : "#26A9B6")};
  cursor: pointer;

  &:hover { background: ${({ $active }) => ($active ? "#1f8f9a" : "#f0fbfc")}; }
`;

/* ---- Table ----
   Cada fila es una píldora blanca independiente sobre el fondo de la página:
   border-collapse: separate + border-spacing vertical para el hueco entre filas,
   y el redondeo/contorno se aplica a la primera y última celda de cada fila. */
export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0 6px;
`;

export const Thead = styled.thead``;

export const Th = styled.th`
  padding: 0 14px 10px;
  text-align: left;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #26A9B6;
  white-space: nowrap;
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  cursor: pointer;

  td {
    background: ${({ $selected }) => ($selected ? "#f4fcfd" : "#fff")};
    border-top: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
    border-bottom: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
  }

  /* Separadores verticales entre columnas (no tras el avatar) */
  td:nth-child(n + 3) { border-left: 1px solid #eef4f8; }

  td:first-child {
    padding: 0 8px;
    border-left: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  td:last-child {
    border-right: 1.5px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  &:hover td { background: ${({ $selected }) => ($selected ? "#f4fcfd" : "#f8fcfe")}; }
`;

export const Td = styled.td`
  height: 40px;
  padding: 0 14px;
  font-size: 0.84rem;
  color: #333;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TherapistName = styled.span`
  font-weight: ${({ $me }) => ($me ? 700 : 400)};
  color: ${({ $me }) => ($me ? "#1b3a6b" : "#333")};
`;

export const AvatarCell = styled.img`
  display: block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`;

export const EmptyRow = styled.tr`
  td {
    padding: 40px;
    text-align: center;
    color: #aaa;
    font-size: 0.9rem;
    background: #fff;
    border-radius: 20px;
  }
`;

/* ---- Action icons ---- */
export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const IconBtn = styled.button`
  position: relative;
  background: none;
  border: none;
  color: #8aa;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  font-size: 1rem;

  &:hover { color: #26A9B6; }
  &:disabled { opacity: 0.3; cursor: not-allowed; }
  &:disabled:hover { color: #8aa; }
`;

export const NotifBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #e53e3e;
  color: #fff;
  font-size: 0.55rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;
